<template>
  <div class="row">
    <div class="col-md-4 reports-tab-container">
      <div class="row report-fields-container">
        <!-- <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.disbursement.date') }}</label>
          <base-select v-model="selectedRange" :options="dateRange" :allow-empty="false" :show-labels="false"
            @input="onChangeDateRange" />
          <span v-if="$v.range.$error && !$v.range.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div> -->
        <div v-if ="userType == 'super_admin'" class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('suppliers.title') }}</label>
          <base-select
            v-model="formData.company_id"
            :options="users"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('suppliers.select_a_supplier')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name" />
        </div>

        <div v-if ="userType == 'super_admin'" class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('reports.disbursement.bank') }}</label>
          <base-select v-model="formData.bank_company_id" :options="banks" :group-select="false" :searchable="true"
                       :show-labels="false" :placeholder="$t('reports.disbursement.select_a_bank')" group-values="options"
                       group-label="label" track-by="id" label="name"/>
        </div>

        <!-- dropdowns for Funders -->
        <div class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('data_exports.reports.buyers') }}</label>
          <base-select
            v-model="formData.customer_id"
            :options="buyers"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('clients.select_a_buyer')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name"
          />
        </div>
        <div class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('suppliers.title') }}</label>
          <base-select
            v-model="formData.user_id"
            :options="users"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('suppliers.select_a_supplier')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name" />
        </div>

      </div>
      <div class="row report-submit-button-container">
        <div class="col-md-6">
          <base-button outline color="theme" class="report-button" @click="getReports()">
            {{ $t('reports.update_report') }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="col-sm-8 reports-tab-container">
      <iframe :src="getReportUrl" class="reports-frame-style" />
      <a class="base-button btn btn-primary btn-lg report-view-button" @click="viewReportsPDF">
        <font-awesome-icon icon="file-pdf" class="vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2" /> <span>{{
        $t('reports.view_pdf') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      reportTypes: ['By Customer', 'By Item'],
      selectedType: 'By Customer',
      // dateRange: [
      //   'Today',
      //   'Weekly',
      //   'Monthly',
      //   'Quaterly'
      // ],
      // selectedRange: 'Today',
      range: new Date(),
      formData: {
        // fr_date_to: new Date(),
        // financing_approved_date: '',
        company_id: null,
        bank_company_id: null,
        customer_id: null,
        user_id: null
      },
      url: null,
      supplierSiteURL: null,
      newParentCustomersArray: [],
      newFunderArray: [],
      newSuppliersArray: [],
      newClientArray: [],
      newBanksArray: [],
      userType: null
    }
  },
  validations: {
    range: {
      // required
    },
    formData: {
      // fr_date_from: {
      //   required
      // },
      // financing_approved_date: {
      //   required
      // }
    }
  },
  computed: {
    ...mapGetters('company', [
      'getSelectedCompany'
    ]),
    ...mapGetters('supplier', [
      'suppliers'
    ]),
    getReportUrl () {
      return this.url
    },

    users: {
      get: function () {
        return [
          {
            label: 'Suppliers',
            isDisable: true,
            options: this.newSuppliersArray
          }
        ]
      },
      set: function (val) {
        if (this.userType == 'super_admin') {
          this.formData.company_id = val
        } else {
          this.formData.user_id = val
        }
      }
    },

    banks: {
      get: function () {
        return [
          {
            label: 'Bank',
            isDisable: true,
            options: this.newFunderArray
          }
        ]
      },
      set: function (val) {
        this.formData.bank_company_id = val
      }
    },

    buyers: {
      get: function () {
        return [
          {
            label: 'Buyers',
            isDisable: true,
            options: this.newClientArray
          }
        ]
      },
      set: function (val) {
        this.formData.customer_id = val
      }
    }

  },
  watch: {
    range (newRange) {
      // this.formData.fr_date_from = moment(newRange).startOf('year').toString()
      // this.formData.fr_date_to = moment(newRange).startOf('year').toString()
      // this.formData.financing_approved_date = moment(newRange).startOf('year').toString()
    },

    'formData.company_id' (value) {
      if (this.userType == 'super_admin') {
        this.formData.bank_company_id = ''
        if (value != null && value.id != 'all') {
          this.fetchSupplierBanks(value.id).then((res) => {
            let supplierBanksArray = res.data.banks
            var supplierBanks = []
            supplierBanksArray.map(row => {
              if (row.company_name != null) {
                supplierBanks.push({ id: row.company_id, name: row.company_name })
              }
            })
            this.newFunderArray = supplierBanks
          })
        } else {
          this.getFunders()
        }
      }
      this.getReports()
    },

    'formData.buyer_company_id' (value) {
      this.getReports()
    },

    'formData.customer_id' (value) {
      this.getReports()
    },

    'formData.bank_company_id' (value) {
      this.getReports()
    },

    'formData.user_id' (value) {
      this.getReports()
    }

  },
  created () {
    let data = { pagination: 'no' }

    if (localStorage.getItem('role') == 'super_admin') {
      this.userType = 'super_admin'
      this.getFunders()
    }

    if (localStorage.getItem('role') == 'admin') {
      this.userType = 'admin'
      this.getBuyers()
    }
    if (localStorage.getItem('role') == 'user') {
      this.userType = 'admin'
      this.getBuyers()
    }
    this.getSuppliers()
  },
  mounted () {
    if (this.$route.path === '/super-admin/reports/disbursement-report') {
      this.$router.push('/super-admin/reports/disbursement-report')
    }
    this.supplierSiteURL = `/reports/disbursement-report/${this.getSelectedCompany.unique_hash}`
    this.getInitialReport()
  },
  methods: {
    ...mapActions('supplier', [
      'fetchSuppliers',
      'fetchSupplierBanks'
    ]),

    ...mapActions('funder', [
      'fetchFunders',
      'fetchAllFunders',
      'fetchBuyersForFunder'
    ]),

    ...mapActions('customer', [
      'fetchCreateCustomer'
    ]),

    async getFunders () {
      await this.fetchAllFunders({pagination: 'no'}).then((res) => {
        let funderArray = res.data.funders
        var selectAllBanks = []
        selectAllBanks.push({ id: 'all', name: 'Select All' })
        funderArray.map(row => {
          if (row.company_name != null) {
            selectAllBanks.push({ id: row.company_id, name: row.company_name })
          }
        })
        this.newFunderArray = selectAllBanks
      })
    },

    async getSuppliers () {
      let res = await this.fetchSuppliers({ pagination: 'no', role: 'admin' })
      let supplierArray = res.data.suppliers.data
      let selectAllSuppliers = []
      selectAllSuppliers.push({ id: 'all', name: 'Select All' })

      if (this.userType == 'admin') {
        supplierArray.map(row => {
          if (row.company_name != null) {
            selectAllSuppliers.push({ id: row.id, name: row.company_name })
          }
        })
      } else {
        supplierArray.map(row => {
          if (row.company_name != null) {
            selectAllSuppliers.push({ id: row.company_id, name: row.company_name })
          }
        })
      }

      this.newSuppliersArray = selectAllSuppliers
    },

    async getBuyers () {
      await this.fetchBuyersForFunder().then((response) => {
        let buyersArray = response.data.buyers
        let selectAllBuyers = []
        selectAllBuyers.push({ id: 'all', name: 'Select All' })
        // Convert to array if it's a collection/object
        buyersArray = Array.isArray(buyersArray) ? buyersArray : Object.values(buyersArray)
        buyersArray.forEach(function (row) {
          selectAllBuyers.push({ id: row.id, name: row.name })
        })
        this.newClientArray = selectAllBuyers
      })
    },

    getThisDate (type, time) {
      return moment()[type](time).toString()
    },
    getPreDate (type, time) {
      return moment().subtract(1, time)[type](time).toString()
    },
    // onChangeDateRange() {
    //   switch (this.selectedRange) {
    //     case 'Today':
    //       this.formData.fr_date_from = moment().toString()
    //       this.formData.fr_date_to = moment().toString()
    //       break

    //     case 'Weekly':
    //       this.formData.fr_date_from = this.getThisDate('startOf', 'isoWeek')
    //       this.formData.fr_date_to = this.getThisDate('endOf', 'isoWeek')
    //       break

    //     case 'Monthly':
    //       this.formData.fr_date_from = this.getThisDate('startOf', 'month')
    //       this.formData.fr_date_to = this.getThisDate('endOf', 'month')
    //       break

    //     case 'Quaterly':
    //       this.formData.fr_date_from = this.getThisDate('startOf', 'quarter')
    //       this.formData.fr_date_to = this.getThisDate('endOf', 'quarter')
    //       break
    //   }
    // },
    setRangeToCustom () {
      this.selectedRange = 'Custom'
    },

    async getInitialReport () {
      // this.url = `${this.supplierSiteURL}?fr_date_from=${moment(this.formData.fr_date_from).format('DD/MM/YYYY')}&fr_date_to=${moment(this.formData.fr_date_to).format('DD/MM/YYYY')}`
      this.url = `${this.supplierSiteURL}?type=preapproved`
      return true
    },

    async viewReportsPDF () {
      let data = await this.getReports()
      window.open(this.getReportUrl, '_blank')
      return data
    },

    async getReports (isDownload = false) {
      // this.$v.range.$touch()
      this.$v.formData.$touch()
      // if (this.$v.$invalid) {
      //   return true
      // }

      // this.url = `${this.supplierSiteURL}?fr_date_from=${moment(this.formData.fr_date_from).format('DD/MM/YYYY')}&fr_date_to=${moment(this.formData.fr_date_to).format('DD/MM/YYYY')}`
      this.url = `${this.supplierSiteURL}?type=preapproved`

      if (this.formData.company_id && this.formData.company_id.id !== 'all') {
        this.url += `&company_id=${this.formData.company_id.id}`
        // this.url += `?company_id=${this.formData.company_id.id}`
      }

      if (this.formData.bank_company_id && this.formData.bank_company_id.id !== 'all') {
        this.url += `&bank_company_id=${this.formData.bank_company_id.id}`
      }

      if (this.formData.customer_id && this.formData.customer_id != null && this.formData.customer_id.id != 'all') {
        this.url += `&customer_id=${this.formData.customer_id.id}`
      }

      if (this.formData.user_id && this.formData.user_id != null && this.formData.user_id.id != 'all') {
        this.url += `&user_id=${this.formData.user_id.id}`
      }

      // if (this.formData.financing_approved_date && this.formData.financing_approved_date != null) {
      //   this.url += `&financing_approved_date=${moment(this.formData.financing_approved_date).format('DD/MM/YYYY')}`
      // }

      return true
    },
    downloadReport () {
      if (!this.getReports()) {
        return false
      }

      window.open(this.getReportUrl + '&download=true')
      setTimeout(() => {
        // this.url = `${this.supplierSiteURL}?fr_date_from=${moment(this.formData.fr_date_from).format('DD/MM/YYYY')}&fr_date_to=${moment(this.formData.fr_date_to).format('DD/MM/YYYY')}`
        this.url = `${this.supplierSiteURL}?type=preapproved`

        if (this.formData.company_id && this.formData.company_id.id !== 'all') {
          // this.url += `&company_id=${this.formData.company_id.id}`
          this.url += `&company_id=${this.formData.company_id.id}`
        }

        if (this.formData.bank_company_id && this.formData.bank_company_id.id !== 'all') {
          this.url += `&bank_company_id=${this.formData.bank_company_id.id}`
        }

        if (this.formData.customer_id && this.formData.customer_id != null && this.formData.customer_id.id != 'all') {
          this.url += `&customer_id=${this.formData.customer_id.id}`
        }

        if (this.formData.user_id && this.formData.user_id != null && this.formData.user_id.id != 'all') {
          this.url += `&user_id=${this.formData.user_id.id}`
        }

        // if (this.formData.financing_approved_date && this.formData.financing_approved_date != null) {
        //   this.url += `&financing_approved_date=${moment(this.formData.financing_approved_date).format('DD/MM/YYYY')}`
        // }
        return true
      }, 200)
    }
  }
}
</script>
